import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/_auth/customer/',
)({
    beforeLoad: () => {
        throw redirect({ to: '/customer/locations' });
    },
});
